<div class="toaster position-fixed d-flex justify-content-center align-items-center w-100 flex-column">
  <div *ngFor="let toast of currentToasts; index as i">
    <app-toast
      [type]="toast.type"
      [title]="toast.title"
      [message]="toast.message"
      (disposeEvent)="dispose(i)"
    ></app-toast>
  </div>
</div>
